<script setup>
import {ref} from 'vue'
import {useUniqueValue} from '@/composables/useUniqueValue'
import vFormValidation from '@/vue/directives/formValidation'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String // Added to support the watch target inside the composable
})

// Accessing the DOM element for validation side-effects
const fieldInputRef = ref(null)

// Initialize Vue 3 style composable logic
useUniqueValue(props, fieldInputRef)

// Instantiate dynamic Pinia Form Store
const formStore = useFormStore(props.formId)

// Emulating the created hook logic
formStore.setDefaultValue({
    name: props.field.name,
    value: ''
})
</script>

<template>
    <p>
        <input v-if="field.readonly" v-model="currentData[field.name]" class="form-control-type-color" disabled
               type="color">
        <input v-else :id="field.id" ref="fieldInputRef" v-model="currentData[field.name]" v-select="field.autofocus"
               v-form-validation
               :disabled="field.disabled" :name="field.name" :required="field.required" autocomplete="off"
               class="form-control-type-color" :class="{'is-invalid': field.error}" type="color">

        {{ currentData[field.name] }}
    </p>
</template>

<style scoped>
p {
    display: flex;
    align-items: center;
}

p > * {
    margin-right: 5px;
}
</style>